
import React, { useRef, useEffect } from "react";
import * as actions from "../Actions";
import Swiper from "react-id-swiper";
import Service from '../../../service/Service';

const service = new Service();

export default function AskqueOverlay({ eleRef, childData }) {

    const questionRef = useRef(null);
    const fileRef = useRef(null);

    useEffect(() => {
        if (questionRef.current) {
            // questionRef.current.focus();
        }
    }, []);

    if (childData) {
        childData = childData.filter(function (item) {
            return !item.IsExpected;
        });
    }

    const closeQuestionPopup = () => {

        if (questionRef.current) {
            questionRef.current.value = "";
        }

        // Clear file input
        if (fileRef.current) {
            fileRef.current.value = "";
        }

        // Hide uploaded file preview
        document.querySelector(".cmt-image .added-file-name").innerHTML = "";
        document.querySelector(".cmt-pdf .added-file-name").innerHTML = "";

        // Optional: hide attachment rows
        document.querySelector(".cmt-image").style.display = "none";
        document.querySelector(".cmt-pdf").style.display = "none";

        eleRef.closeAskquestion();
    };

    const childSwiperParams = {
        slidesPerView: "auto",
        spaceBetween: 10,
        observer: true,
        speed: 600,          // Smooth slide animation
        grabCursor: true,
        watchSlidesProgress: true,
        simulateTouch: true,
        touchStartPreventDefault: true,
        touchMoveStopPropagation: true,
    };

    const handleAttachmentCallback = () => {
        if(eleRef.state.isApp){

            const fname = Math.round(new Date().getTime() / 1000) +"_" +new Date().getTime();

            const appMXPJson = {
                appurl: [
                    {
                        pagetype: "uploadfile",
                        uniqueIdForFile: eleRef.state.selectedChildId,
                        FileName: fname,
                        ModuleType: "askQueImage",
                    },
                ],
            };

            service.jsontracker(JSON.stringify(appMXPJson));
        }
    };

    return (
        <div className="askQuest-overlay askquemob" >
            <div className="newAskQueDesign" onClick={(e) => e.stopPropagation()} >
                {/* Header */}
                <div className="newAskQueHeader">
                    <span className="backArrow" onClick={closeQuestionPopup} >
                        <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png" alt="back arrow"></img>
                    </span>
                    <span className="postButton" onClick={actions.saveQuestion.bind(this,eleRef.state.selectedChildId,eleRef)}>
                        Post 
                        <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/ic-send.png" alt="send"></img>
                    </span>
                </div>
                <div className="askQueTitle">
                    <div className="askQueTitle_div">
                        Ask a Question
                        <span></span>
                    </div>
                </div>
                <div className="titleBorder"></div>
                <div className="queAskedText">
                    This question is being asked for
                </div>
                {/* Child List */}
               
                <div className="childScrollWrapper">
                    <Swiper {...childSwiperParams}>
                        {childData && childData.length > 0 && childData.map((child, index) => (
                                <div key={child.ChildId} className="childSlide">
                                    <label className={`childCard ${ eleRef.state.selectedChildId == child.ChildId ? "active" : "" }`} >
                                        <input type="radio" name="childSelect" value={child.ChildId} checked={eleRef.state.selectedChildId == child.ChildId}
                                            onChange={() => 
                                                eleRef.setState({
                                                    selectedChildId: child.ChildId,
                                                    selectedChild: child
                                                })
                                            }
                                            className="hiddenRadio"
                                        />

                                        {child.Gender?.toLowerCase() === "boy" ? (
                                            <div className={`childAvatar ${child.Gender}`}>
                                                <img src={ child.childPhoto || "https://cdn.cdnparenting.com/brainbees/community/Images_folder/ic_boy_community.png" }
                                                    alt={child.ChildName}
                                                />
                                            </div>
                                        ) : (
                                            <div className={`childAvatar ${child.Gender}`}>
                                                <img src={ child.childPhoto || "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_girl_community.jpg"
                                                    }
                                                    alt={child.ChildName}
                                                />
                                            </div>
                                        )}

                                        <div className="childInfo">
                                            <span className={`childName ${child.Gender}`}>
                                                {child.ChildName}
                                            </span>

                                            <span className="childAge">
                                                {actions.getShortAge(child.DOB)}
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            ))}

                        <div className="childSlide">
                            <label
                                className={`childCard ${
                                    eleRef.state.selectedChildId == "all" ? "active" : ""
                                }`}
                            >
                                <input type="radio" value="all" checked={eleRef.state.selectedChildId == "all"}
                                    onChange={() => eleRef.setState({
                                            selectedChildId: "all"
                                        })
                                    }
                                    className="hiddenRadio"
                                />

                                <div className="childAvatar">
                                    <img src={ eleRef.state.userPhoto || "https://cdn.cdnparenting.com/brainbees/community/vaccination/default-img.png"
                                        }
                                        alt="Myself"
                                    />
                                </div>

                                <div className="childInfo">
                                    <span className="childName">Myself</span>
                                </div>
                            </label>
                        </div>
                    </Swiper>
                </div>

                {/* Textarea */}
                {/* <textarea id="post_question_text" rows="5" className="newQuestionBox" placeholder={`Write Your Question Here ...`}></textarea> */}
                <textarea ref={questionRef} id="post_question_text" rows="5" className="newQuestionBox" placeholder={`Write Your Question Here ...`}></textarea>
                <div className="file_upload_err"></div>
                {/* Attachment */}
                <label htmlFor="fileupload_askq" className="attachmentBox" onClick={handleAttachmentCallback}>
                    <div className="attachmentIcon" >
                        <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/attachment.png" alt="attachment"></img>
                    </div>
                    <span>Attachments</span>
                </label>

                {/* Uploaded files */}
                <div className="uploaded-files-list">
                    <ul>

                        <li className="cmt-image">
                            <span data-icon-font="`" className="icon left" ></span>
                            <span className="added-file-name left"></span>
                            <span data-icon-font="&#xe013;" className="icon right" onClick={actions.cmtFileDelete.bind( this,"image","que")}></span>
                        </li>

                        <li className="cmt-pdf">
                            <span data-icon-font="&#xe039;" className="icon left" ></span>
                            <span className="added-file-name left"></span>
                            <span data-icon-font="&#xe013;" className="icon right" onClick={actions.cmtFileDelete.bind(this,"pdf","que")}></span>
                        </li>
                    </ul>
                </div>

                <input ref={fileRef} type="file" id="fileupload_askq" onChange={(e) => actions.cmtFileUploadMyAns()} style={{ display: "none" }} />

            </div>
        </div>
    );
}

